import { useEffect, useRef, useState } from 'react';

const BarcodeScanner = ({ onDetected, onClose }) => {
  const videoRef = useRef(null);
  const controlsRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const start = async () => {
      try {
        const { BrowserMultiFormatReader } = await import('@zxing/browser');
        if (cancelled) return;
        const reader = new BrowserMultiFormatReader();
        const controls = await reader.decodeFromVideoDevice(
          undefined,
          videoRef.current,
          (result, err) => {
            if (result) {
              controls.stop();
              onDetected(result.getText());
            }
          }
        );
        controlsRef.current = controls;
      } catch (err) {
        if (!cancelled) {
          const msg = err?.name === 'NotAllowedError'
            ? 'Camera access denied. Please allow camera access and try again.'
            : err?.name === 'NotFoundError'
            ? 'No camera found on this device.'
            : 'Could not start camera.';
          setError(msg);
        }
      }
    };

    start();
    return () => {
      cancelled = true;
      controlsRef.current?.stop();
    };
  }, []); // eslint-disable-line

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Scan Barcode</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        {error ? (
          <div style={{ padding: '1.5rem', textAlign: 'center' }}>
            <p style={{ color: 'var(--danger)', marginBottom: '1rem', fontSize: '0.9rem' }}>{error}</p>
            <button className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        ) : (
          <div style={{ padding: '1rem' }}>
            <p style={{ fontSize: '0.85rem', color: 'var(--muted)', marginBottom: '0.75rem', textAlign: 'center' }}>
              Point camera at the product barcode
            </p>
            <video
              ref={videoRef}
              style={{ width: '100%', borderRadius: 8, background: '#000', display: 'block' }}
              autoPlay
              playsInline
              muted
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BarcodeScanner;
